import { render, staticRenderFns } from "./IframeContainer.vue?vue&type=template&id=dd8dbd2c&scoped=true"
import script from "./IframeContainer.vue?vue&type=script&lang=js"
export * from "./IframeContainer.vue?vue&type=script&lang=js"
import style0 from "./IframeContainer.vue?vue&type=style&index=0&id=dd8dbd2c&prod&lang=scss&scoped=true"
import style1 from "./IframeContainer.vue?vue&type=style&index=1&id=dd8dbd2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8dbd2c",
  null
  
)

export default component.exports